import {
  Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ChangeDetectionStrategy, OnChanges, SimpleChanges, SimpleChange, ViewChild
} from '@angular/core';
import {Column, DataTable, FilterOperator} from '../../base';
import {Keys} from '../../../common';
import { CommonFilterService } from 'src/app/shared/services/common-filter/common-filter.service';

@Component({
  selector: 'app-string-filter',
  templateUrl: 'string-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StringFilterComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() table: DataTable;
  @Input() rsltType: string;
  @Input() column: Column;
  @Input() isOpen: boolean;
  @Output() filterClose: EventEmitter<boolean> = new EventEmitter();

  @ViewChild('filterInput', {static: false}) filterInput: any;

  matchMode: string;
  value: any;
  operators: any[];
  defaultMatchMode = FilterOperator.STARTS_WITH;

  constructor(private commonFilterService: CommonFilterService) { }

  ngOnInit() {
    this.operators = [
      {value: FilterOperator.EQUALS, text: this.table.messages.equals},
      {value: FilterOperator.NOT_EQUAL, text: this.table.messages.notEqual},
      {value: FilterOperator.STARTS_WITH, text: this.table.messages.startsWith},
      {value: FilterOperator.ENDS_WITH, text: this.table.messages.endsWith},
      {value: FilterOperator.CONTAINS, text: this.table.messages.contains},
      {value: FilterOperator.NOT_CONTAINS, text: this.table.messages.notContains},
      //{value: FilterOperator.IS_EMPTY, text: this.table.messages.isEmpty},
      //{value: FilterOperator.IS_NOT_EMPTY, text: this.table.messages.isNotEmpty},
    ];
  }

  ngAfterViewInit() {
    this.commonFilterService.GeneralFilter.subscribe(res => {
      //console.log(res)
      this.table.dataFilter.filters = res;
      this.matchMode = this.table.dataFilter.getFilterMatchMode(this.column.name) || this.defaultMatchMode;
      this.value = this.table.dataFilter.getFilterValue(this.column.name);
      this.setFocus();
    });   
  }

  ngOnChanges(): void {
    if (this.column.name) {
      this.matchMode = this.table.dataFilter.getFilterMatchMode(this.column.name) || this.defaultMatchMode;
      this.value = this.table.dataFilter.getFilterValue(this.column.name);
      if (this.column.name.toLowerCase().indexOf('vquad_callid') != -1 && this.matchMode.toLowerCase().indexOf('contains') != -1
        && this.value.indexOf('_') == 0 && this.value.lastIndexOf('_') == this.value.length - 1
        && this.value.substring(1, this.value.length - 1).indexOf('_') == -1) {
        this.value = this.value.substring(1, this.value.length - 1);
        this.matchMode = this.matchMode.indexOf('not') != -1 ? 'notEqual' : 'equals';
      }
    }
    this.setFocus();
  }

  get isValueFilter() {
    return !this.table.dataFilter.isNonValueFilter(this.matchMode);
  }

  saveFilter() {
    let colName = this.column.name.toLowerCase();

    //For VBA only
    let newColName = this.column.name;
    if (colName == 'phone_id') {
      colName = 'vquad_phoneid';
      newColName = 'VQuad_PhoneID';
    }
    else if (colName == 'location') {
      colName = 'vquad_location';
      newColName = 'VQuad_Location';
    }

    if (colName.indexOf('vquad') != -1 || colName.indexOf('calltype') != -1 || colName.indexOf('gps') != -1)
      this.rsltType = "";

    if (colName.indexOf('start_gps') != -1)
      this.rsltType = "nettest|mobileinfo|vac";
    if (colName.indexOf('net_speed_test') != -1 || colName.indexOf('network_type') != -1 || colName.indexOf('tn_number') != -1 || colName.indexOf('target_server') != -1 ||
      (colName.indexOf('teststatus') != -1 && this.rsltType != 'vac'))
      this.rsltType = "nettest|mobileinfo";

    if (colName.indexOf('vquad_callid') != -1) {
      this.commonFilterService.setGeneralEventIDFilterData({});//clear event id subscribe here
    }

    //if (this.matchMode.toLowerCase().indexOf('contains') != -1
    //  && this.value.indexOf('_') == 0 && this.value.lastIndexOf('_') == this.value.length - 1
    //  && this.value.substring(1, this.value.length - 1).indexOf('_') == -1) {
    //  let newVal = this.value.substring(1, this.value.length - 1);
    //  let newMatchMode = this.matchMode.indexOf('not') != -1 ? 'notEqual' : 'equals';
    //}
    if (colName.indexOf('vquad_callid') != -1 && this.matchMode.toLowerCase().indexOf('equal') != -1 && this.value.indexOf('_') == -1) {
      this.value = "_" + this.value + "_";//dynamically changing Event filtering for either Cal ID or Device ID when equals or not equals operator selected
      this.matchMode = FilterOperator.CONTAINS;
      if (this.matchMode.toLowerCase().indexOf('not') != -1)
        this.matchMode = FilterOperator.NOT_CONTAINS;
    }

    this.table.dataFilter.setFilter(this.value, newColName, this.matchMode, null, this.column.dataType, this.rsltType, this.column.title);
    this.table.events.onFilter();
  }

  setFocus() {    
    if (this.filterInput && this.isValueFilter) {
      setTimeout(() => {
        this.filterInput.nativeElement.focus();
      }, 1);
    }
  }

  onModeChange() {
    //console.log(this.isValueFilter + "::" + this.value)
    if (!this.isValueFilter) {
      this.value = 0;
      this.saveFilter();
      this.filterClose.emit(true);
    } else if (this.value === 0) {
      this.value = null;
    }
  }

  onClickOk() {
    this.saveFilter();
    this.filterClose.emit(true);
  }

  onClickCancel() {
    this.filterClose.emit(true);
  }

  onClickClear() {
    this.value = null;
    this.matchMode = this.defaultMatchMode;
    this.saveFilter();
    this.filterClose.emit(true);
  }

  onKeyPressFilterInput(event: KeyboardEvent) {
    if (event.which === Keys.ENTER) {
      this.onClickOk();
    }
  }

}
